import { render, staticRenderFns } from "./CompanyHeaderModule.vue?vue&type=template&id=99cee264&scoped=true"
import script from "./CompanyHeaderModule.vue?vue&type=script&lang=js"
export * from "./CompanyHeaderModule.vue?vue&type=script&lang=js"
import style0 from "./CompanyHeaderModule.vue?vue&type=style&index=0&id=99cee264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cee264",
  null
  
)

export default component.exports